import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

interface ConfirmModalProps {
  show: boolean;
  onNo: () => void;
  onYes: (e: any) => void;
  title?: string;
  body?: string;
  closeButtonText?: string;
  confirmButtonText?: string;
  // Legacy props — accepted for backwards compat with older call sites,
  // ignored by the new token-driven layout.
  showIcon?: boolean;
  showDeleteIcon?: boolean;
  // Bootstrap-icons class for the icon circle (e.g. "bi-box-arrow-right").
  // Defaults to a trash icon for destructive confirmations and a logout
  // arrow for the primary variant.
  iconClass?: string;
  // "danger" — red icon + red confirm button (delete-style flows, the
  // default since most call sites are deletes). "primary" — brand-green
  // for non-destructive confirmations like logout.
  variant?: "danger" | "primary";
}

const Confirm: React.FC<ConfirmModalProps> = ({
  show,
  onNo,
  onYes,
  title = "Are you sure?",
  body,
  closeButtonText = "Cancel",
  confirmButtonText = "Delete",
  iconClass,
  variant = "danger",
}) => {
  const isDanger = variant === "danger";
  const resolvedIcon =
    iconClass || (isDanger ? "bi-trash3" : "bi-box-arrow-right");

  return (
    <Modal
      show={show}
      onHide={onNo}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="confirmModal"
    >
      <Modal.Body>
        <div
          className={`confirmModal__icon ${
            isDanger ? "confirmModal__icon--danger" : ""
          }`}
        >
          <i className={`bi ${resolvedIcon}`} aria-hidden="true" />
        </div>
        <h2 className="confirmModal__title">{title}</h2>
        {body ? <p className="confirmModal__subtitle">{body}</p> : null}
        <div className="confirmModal__footer">
          <Button className="closeBtn" variant="secondary" onClick={onNo}>
            {closeButtonText}
          </Button>
          <button
            type="button"
            className={
              isDanger ? "confirmModal__danger" : "confirmModal__primary"
            }
            onClick={onYes}
          >
            {confirmButtonText}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Confirm;
